import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { callNavigateButton } from "../../../Services/redux";
import {
  fetchSubmissionDetails,
  fetchPortfolioContentDetails,
  postSubmissionDetails,
} from "../../../Services/redux/Application-details/ApplicationDetailsActions";
import { fetchApplicationDetails } from "../../../Services/redux/appId-details/AppIdDeatilsActions";
import { fetchCategoryDetails } from "../../../Services/redux/Category/CategoryActions";
import {
  fetchLanguageDetails,
  fetchCurrentLanguage,
} from "../../../Services/redux/languages-details/LanguageDetailsActions";
import { Container, Grid2 } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Topheader from "../../../Layout/header/header";
import ApplicationDetailsSideMenu from "../../../Components/ApplicationDetailsSideMenu/ApplicationDetailsSideMenu";
import ListingHeader from "../../../Components/ListingHeader/ListingHeader";
import ApplicationDetailsAPKFile from "../../../Components/APKFile/ApplicationDetailsAPKFile";
import AppDetailsLanguage from "../../../Components/ApplicationDetails-Language/AppDetailsLanguage";
import ApplicationDetailsIcon from "../../../Components/ApplicationDetailsIcon/ApplicationDetailsIcon";
import ApplicationDetailsCategory from "../../../Components/ApplicationDetailsCategory/ApplicationDetailsCategory";
import ApplicationDetailsRollout from "../../../Components/ApplicationDetailsRollout/ApplicationDetailsRollout";
import ApplicationDetailsAdditionalDocument from "../../../Components/ApplicationDetailsAdditionalDocument/ApplicationDetailsAdditionalDocument";
import AppDetailsLicensing from "../../../Components/ApplicationDetails-Licensing/AppDetailsLicensing";
import ApplicationDetailsClusterCompatibity from "../../../Components/ApplicationDetailsClusterCompatibity/ApplicationDetailsClusterCompatibity";
import ApplicationDetailsDLCM from "../../../Components/ApplicationDetailsDLCM/ApplicationDetailsDLCM";
import ApplicationDetailsLegalDocuments from "../../../Components/ApplicationDetailsLegalDocuments/ApplicationDetailsLegalDocuments";
import DomainApproverApplicationDetailsTargeting from "../../../Components/domain-approver-application-details-targeting/DomainApproverApplicationDetailsTargeting";
import ApplicationDetailsAgeRatingAds from "../../../Components/ApplicationDetails-Age-Rating-Ads/ApplicationDetailsAgeRatingAds";
import AppDependencyReadOnly from "../../../Components/AppDependencyReadOnly/AppDependencyReadOnly"
function DomainApproverApplicationDetails() {
  const { appId, submissionId } = useParams();
  const appMultiSubmissionId = submissionId;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loader, setLoader] = useState(true);
  const thirdPartyApps = globalThis.location.href.includes("third-party-apps");
  const APKfileRef = useRef(null);
  const [submissionDetailsFetched, setSubmissionDetailsFetched] =
    useState(false);
  const appData = useSelector(
    (state) => state.applicationDetails.applicationDetails
  );
  const { submissionDetails } = useSelector((state) => state.submissionDetails);
  const categoryData = useSelector((state) => state.categoryDetails);
  const languageData = useSelector((state) => state.languageDetails.languages);

  const getNavigationConfig = () => {
    const currentTab = sessionStorage.getItem("domain-approver-selectedTab");
    const currentStatus = sessionStorage.getItem(
      "domain-approver-activeStatus"
    );

    if (thirdPartyApps || currentTab === "1") {
      return {
        shouldPersistStatus: false,
        targetStatus: "SUBMITTED_FOR_PRODUCTION",
      };
    }
    return {
      shouldPersistStatus: true,
      targetStatus: currentStatus || "SUBMITTED_FOR_PRODUCTION",
    };
  };

  const navigateToApplications = () => {
    const navigationConfig = getNavigationConfig();
    sessionStorage.setItem("domain-approver-selectedTab", "0");
    sessionStorage.setItem(
      "domain-approver-activeStatus",
      navigationConfig.targetStatus
    );
    navigate("/ui/domain-approver/applications", {
      replace: true,
      state: {
        refresh: Date.now(),
        selectedTab: 0,
        fromContext: navigationConfig.shouldPersistStatus
          ? "groupApps"
          : "thirdPartyApps",
      },
    });
  };

  const callNewSubmissionId = (submssonId) => {
    setSubmissionDetailsFetched(false); // Reset fetch state for new submission
    dispatch(fetchSubmissionDetails(appId, submssonId));
  };
  const callPostSubmissionRequest = (status, forceInstall) => {
    dispatch(postSubmissionDetails(appId, submissionId, status, forceInstall));
    navigateToApplications();
  };
  useEffect(() => {
    dispatch(fetchLanguageDetails("en-001"));
    return () => {
      dispatch(callNavigateButton());
    };
  }, [dispatch, thirdPartyApps]);

  useEffect(() => {
    if (thirdPartyApps) {
      dispatch(fetchPortfolioContentDetails(undefined, appId));
    } else {
      dispatch(fetchCategoryDetails());
      dispatch(fetchApplicationDetails(appId));
    }
  }, [appId, dispatch, thirdPartyApps]);

  useEffect(() => {
    if (!thirdPartyApps && !submissionDetailsFetched && appId && submissionId) {
      dispatch(fetchSubmissionDetails(appId, submissionId));
      setSubmissionDetailsFetched(true);
    }
  }, [appId, submissionId, thirdPartyApps, submissionDetailsFetched, dispatch]);

  useEffect(() => {
    if (submissionDetails?.descriptions?.length > 0) {
      setLoader(false);

      if (sessionStorage.getItem("currentLanguage")) {
        dispatch(
          fetchCurrentLanguage(sessionStorage.getItem("currentLanguage"))
        );
      } else {
        dispatch(fetchCurrentLanguage(submissionDetails.defaultLanguage));
      }
    }
  }, [submissionDetails, dispatch]);

  const backToApplications = () => {
    sessionStorage.removeItem("currentLanguage");
    navigateToApplications();
  };

  return (
    <>
      <Topheader />
      {!loader && (
        <Container maxWidth="lg">
          <Grid2 container>
            <Grid2 size={12}></Grid2>
            <div
              className="container-application-details"
              style={
                submissionDetails.status === "DRAFT"
                  ? {
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                    }
                  : { display: "flex", flexDirection: "row" }
              }
            >
              <div
                className="side-menu"
                style={
                  submissionDetails.status === "DRAFT"
                    ? { marginTop: "0px" }
                    : { marginTop: "69px" }
                }
              >
                <button
                  className="arrow-back"
                  onClick={backToApplications}
                  style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <ArrowBackIcon style={{ color: "#717273" }} />
                  </div>
                  <div className="my-apps">My Apps</div>
                </button>
                {submissionDetails &&
                Object.keys(submissionDetails).length > 0 &&
                appData &&
                Object.keys(appData).length > 0 &&
                !thirdPartyApps ? (
                  <ApplicationDetailsSideMenu
                    appData={appData}
                    appMultiSubmissionId={appMultiSubmissionId}
                    callNewSubmissionId={callNewSubmissionId}
                  />
                ) : (
                  <ApplicationDetailsSideMenu
                    submissionData={submissionDetails}
                  />
                )}
              </div>
              <div
                className="submission-container"
                style={
                  submissionDetails.status === "DRAFT"
                    ? { marginLeft: "0" }
                    : { width: "100%", marginLeft: "13%" }
                }
              >
                <div
                  className="fixed-content-application-details"
                  style={
                    submissionDetails.status === "DRAFT"
                      ? {
                          width: "1160px",
                        }
                      : {
                          width: "1010px",
                        }
                  }
                >
                  <ListingHeader
                    callPostSubmissionRequest={callPostSubmissionRequest}
                  />
                </div>
                <div className="scrollable-content">
                  {Object.keys(submissionDetails).length > 0 && (
                    <ApplicationDetailsAPKFile
                      ref={APKfileRef}
                      id="apkfile"
                      submissionData={submissionDetails}
                    />
                  )}
                  <AppDependencyReadOnly />
                  {languageData.length > 0 &&
                  Object.keys(submissionDetails).length > 0 ? (
                    <AppDetailsLanguage
                      languageData={languageData}
                      submissionData={submissionDetails}
                    />
                  ) : null}

                  {submissionDetails &&
                    Object.keys(submissionDetails).length > 0 && (
                      <ApplicationDetailsIcon
                        submissionData={submissionDetails}
                      />
                    )}

                    <ApplicationDetailsAgeRatingAds/>
                  {sessionStorage.getItem("idpLogin") === "true" && (
                    <ApplicationDetailsClusterCompatibity />
                  )}
                  {sessionStorage.getItem("idpLogin") === "true" && (
                    <ApplicationDetailsDLCM />
                  )}
                  <ApplicationDetailsAdditionalDocument
                    submissionData={submissionDetails}
                    appId={appId}
                  />
                  {!thirdPartyApps && <AppDetailsLicensing />}

                  {submissionDetails &&
                  Object.keys(submissionDetails).length > 0 &&
                  !thirdPartyApps ? (
                    <ApplicationDetailsCategory
                      submissionData={submissionDetails}
                      categoryData={categoryData.categories}
                    />
                  ) : (
                    <ApplicationDetailsCategory
                      submissionData={submissionDetails}
                    />
                  )}
                  {submissionDetails &&
                    Object.keys(submissionDetails).length > 0 &&
                    sessionStorage.getItem("idpLogin") === "true" &&
                    !thirdPartyApps && <ApplicationDetailsLegalDocuments />}
                  {submissionDetails &&
                  Object.keys(submissionDetails).length > 0 ? (
                    <DomainApproverApplicationDetailsTargeting
                      targettingData={submissionDetails}
                      appData={appData}
                      appId={appId}
                    />
                  ) : (
                    <div>No data found.</div>
                  )}
                  <ApplicationDetailsRollout />
                </div>
              </div>
            </div>
          </Grid2>
        </Container>
      )}
    </>
  );
}

export default DomainApproverApplicationDetails;
